module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/x-75e1615da1b5b1a6fa49b8f94b36620e.svg";